'use client'

import styled from 'styled-components'

export const StepWrapper = styled.div`
  display: flex;
  margin: 1.5rem 0;
`

interface IBulletStyleProps {
  set?: boolean
  colorType?: string
}

export const Bullet = styled.div<IBulletStyleProps>`
  ${({ set, colorType }) => `
    display: block;
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${colorType};
    margin: 0 10px;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      ${
        set
          ? `
        width: 5px;
        height: 5px;
      `
          : `
        width: 0;
        height: 0;
      `
      }
      border-radius: 50%;
      background-color: #FFFFFF;
      transition: all 0.2s ease-in-out;
    }
  `}
`

